import React, { useState, useEffect } from 'react';

import { SearchButton } from '../../Res/BaseButton';
import { ContentBox } from '../ContentBox';
import { getval2Token, getUserInfoCompanyId, setVal2Token } from '../../../Login/Auth';
import { SingleText, SingleSelect } from '../../Res/BaseInput';
import moment from 'moment';
import { contractorAttendanceStatusAttr, ReqContractorAttendance, ReqInsuranceRecruitmentItem, ReqInsuranceCostItem, contractorAttendanceStatusAttr_Register } from '../../../../item/ItemContractorAttendance';
import { api_updateContractorAttendance } from '../../../../api/apiContractorAttendancee';
import { RespCustomerPositionDetail, getInsuranceSOPTypeString, getInsuranceBurdenTypeString, getGroupInsuranceTypeString, RespCustomerPositionInfo, getDateOfInsuranceString, ReqCustomerPositionList, RespCustomerPositionInfo_Insurance, GroupInsuranceType_NoNeed, getMarginCalculationTypeString } from '../../../../item/ItemCustomerPosition';
import Swal from 'sweetalert2';
import { api_getLaborInsuranceLevel_Arr, api_getHealthInsuranceLevel_Arr } from '../../../../api/apiOpenData';
import { api_getCustomerPositionList } from '../../../../api/apiCustomerPosition';
import { ContractorInsuranceCostList } from './ContractorInsuranceCostList';


export function ContractorInsuranceCost({ id, setIsLoading, type = "" }) {
  const [tokenId, setTokenId] = useState("")
  const [contractorAttendance, setContractorAttendance] = useState({})

  const [companyId] = useState(getUserInfoCompanyId())
  const [contractorAttendanceId, setContractorAttendanceId] = useState("")
  const [customerContractId, setCustomerContractId] = useState("")
  const [contractorAttendanceSOPName, setContractorAttendanceSOPName] = useState("")
  const [creatAt, setCreatAt] = useState("")
  const [creatName, setCreatName] = useState("")
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [dates, setDates] = useState("")
  const [Status, setStatus] = useState("")

  const [CustomerPositionListItems, setCustomerPositionListItems] = useState([])
  const [RecruitmentList, setRecruitmentList] = useState([])
  const [InsuranceListItems, setInsuranceListItems] = useState({})
  const [laborInsuranceLevel_Arr, setLaborInsuranceLevel_arr] = useState([])
  const [healthInsuranceLevel_Arr, setHealthInsuranceLevel_Arr] = useState([])

  const [InsuranceCostItem, setInsuranceCostItem] = useState({})

  // const [salaryMonthly, setSalaryMonthly] = useState(undefined)

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      setTokenId(id)
      // console.log(type)
      var obj = getval2Token("salary" + type, id)
      // console.log(obj)

      var mReqContractorAttendance = new ReqContractorAttendance({})
      mReqContractorAttendance.fromJson(obj.contractorAttendance)
      setContractorAttendance(mReqContractorAttendance)

      var salary
      if (type === "Monthly") {
        salary = mReqContractorAttendance.info.salaryMonthly
      } else if (type === "Hourly") {
        salary = mReqContractorAttendance.info.salaryHourly
      }
      console.log(salary)
      console.log(mReqContractorAttendance)
      setContractorAttendanceId(mReqContractorAttendance.contractorAttendanceId)
      setContractorAttendanceSOPName(mReqContractorAttendance.contractorAttendanceSOPName)
      setCreatAt(moment(mReqContractorAttendance.creatAt).format('YYYY/MM/DD HH:mm:ss'))
      setCreatName(obj.contractorAttendance.creatName)
      setStartDate(moment(mReqContractorAttendance.startDate).format('YYYY/MM/DD'))
      setEndDate(moment(mReqContractorAttendance.endDate).format('YYYY/MM/DD'))
      setDates(obj.contractorAttendance.dates)
      // setContractorAttendanceId(obj.contractorAttendanceId)
      setCustomerContractId(mReqContractorAttendance.customerContractId)

      if (salary !== undefined) {
        setCustomerPositionListItems(salary.CustomerPositionListItems)
        setRecruitmentList(salary.RecruitmentList)
        setInsuranceListItems(salary.InsuranceListItems)

        setInsuranceCostItem(salary.InsuranceCostItem)
        setStatus(salary.InsuranceCostItem.Status)
      }

      getLaborInsuranceLevel_Arr()
      getHealthInsuranceLevel_Arr()

      // setContractorAttendanceSOPName(obj.contractorAttendanceSOPName)
      // const startDate = moment(obj.startDate).format('YYYY/MM/DD')
      // const endDate = moment(obj.endDate).format('YYYY/MM/DD')
      // if (startDate)
      //   setDates(startDate + "～" + endDate)
    }
  }, [id])


  function getInsuranceList() {
    if (customerContractId === undefined || customerContractId === "") return
    Swal.fire({
      type: 'warning',
      title: "已經登錄的資料會遺失",
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: '確定',
      cancelButtonText: '取消',
      allowEscapeKey: false,
      allowOutsideClick: false
    }).then(function (result) {
      // console.log(result)
      if (result.value) {
        if (setIsLoading !== undefined)
          setIsLoading(true)

        var mReqCustomerPositionList = new ReqCustomerPositionList({ customerContractId })
        api_getCustomerPositionList({
          mReqCustomerPositionList,
          success: (obj) => {
            console.log(obj)
            var items = {}
            obj.list.map(item => {
              // console.log(item)
              var info = new RespCustomerPositionInfo({})
              info.fromJson(item.info)
              var mRespCustomerPositionInfo_Insurance = new RespCustomerPositionInfo_Insurance({})
              mRespCustomerPositionInfo_Insurance.fromJson(info.insuranceInfo)
              // console.log(mRespCustomerPositionInfo_Insurance)
              var laborInsuranceAmount = getLaborInsuranceAmount(mRespCustomerPositionInfo_Insurance.laborInsuranceType, mRespCustomerPositionInfo_Insurance.laborInsuranceLevel)
              mRespCustomerPositionInfo_Insurance.setLaborInsuranceAmount(laborInsuranceAmount)
              var healthInsuranceAmount = getHealthInsuranceAmount(mRespCustomerPositionInfo_Insurance.healthInsuranceLevel)
              mRespCustomerPositionInfo_Insurance.setHealthInsuranceAmount(healthInsuranceAmount)

              if (item.customerPositionId !== undefined)
                items[item.customerPositionId] = mRespCustomerPositionInfo_Insurance
            })
            // console.log(items)
            setInsuranceListItems(items)

            var mReqContractorAttendance = new ReqContractorAttendance({})
            mReqContractorAttendance.fromJson(contractorAttendance)

            var InsuranceRecruitmentList = []
            RecruitmentList.forEach((recruitment, index) => {
              console.log(recruitment.PositionInfo.wageInfo.InsuranceBurdenType)
              var mReqInsuranceRecruitmentItem = new ReqInsuranceRecruitmentItem({
                caseContractor: recruitment.caseContractor,
                Name: recruitment.Name,
                Job: recruitment.Job,
                AttendanceDay: recruitment.AttendanceDay,
                Salary: recruitment.Salary,
                LaborInsuranceLevelAmount: items[recruitment.customerPositionId].laborInsuranceAmount,
                HealthInsuranceLevelAmount: items[recruitment.customerPositionId].healthInsuranceAmount,
                GroupInsurancePremium: items[recruitment.customerPositionId].groupInsurancePremium,
                InsuranceBurdenType: parseInt(recruitment.PositionInfo.wageInfo.InsuranceBurdenType),
                GroupInsuranceBurdenType: parseInt(items[recruitment.customerPositionId].groupInsuranceBurdenType),
                PreServiceFee: recruitment.PreServiceFee

              })
              mReqInsuranceRecruitmentItem.setAmount(InsuranceCostItem.InsuranceCostRate)
              InsuranceRecruitmentList.push(mReqInsuranceRecruitmentItem)
            })

            var mInsuranceCostItem = new ReqInsuranceCostItem({})
            mInsuranceCostItem.fromJson(InsuranceCostItem)
            mInsuranceCostItem.setInsuranceRecruitmentList(InsuranceRecruitmentList)
            mInsuranceCostItem.setInsuranceAmount()
            setInsuranceCostItem(mInsuranceCostItem)

            if (type === "Monthly") {
              mReqContractorAttendance.info.salaryMonthly.InsuranceListItems = items
              mReqContractorAttendance.info.salaryMonthly.InsuranceCostItem = mInsuranceCostItem
            } else if (type === "Hourly") {
              mReqContractorAttendance.info.salaryHourly.InsuranceListItems = items
              mReqContractorAttendance.info.salaryHourly.InsuranceCostItem = mInsuranceCostItem
            }
            console.log(mInsuranceCostItem)
            console.log(mReqContractorAttendance)


            toSave(mReqContractorAttendance)
            if (setIsLoading !== undefined)
              setIsLoading(false)
          },
          failure: (err) => {
            console.log(err)
            if (setIsLoading !== undefined)
              setIsLoading(false)
            //window.location.replace("/AdminManagerList");
          }
        })
        // console.log(mReqCustomerPositionList)

      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    })
  }


  function getLaborInsuranceLevel_Arr() {
    if (laborInsuranceLevel_Arr.length > 0)
      return
    api_getLaborInsuranceLevel_Arr({
      success: (jsonData) => {
        try {
          var detail = JSON.parse(jsonData.detail.info)
          setLaborInsuranceLevel_arr(detail)
          // console.log(detail)
        } catch (error) {
          console.log(error)
        }
      },
      failure: (err) => {

      }
    })
  }

  function getHealthInsuranceLevel_Arr() {
    if (healthInsuranceLevel_Arr.length > 0)
      return
    api_getHealthInsuranceLevel_Arr({
      success: (jsonData) => {
        // console.log(jsonData)
        var detail = JSON.parse(jsonData.detail.info)
        setHealthInsuranceLevel_Arr(detail)
      },
      failure: (err) => {

      }
    })
  }

  function getLaborInsuranceAmount(laborInsuranceType, laborInsuranceLevel) {
    var laborInsuranceAmount = 0
    // console.log(Object.keys(laborInsuranceLevel_Arr).length)
    if (Object.keys(laborInsuranceLevel_Arr).length > 0) {
      // console.log(laborInsuranceLevel_Arr[laborInsuranceType + ""][laborInsuranceLevel - 1]["amount"])
      laborInsuranceAmount = laborInsuranceLevel_Arr[laborInsuranceType + ""][laborInsuranceLevel - 1]["amount"]
    }
    return laborInsuranceAmount
  }

  function getHealthInsuranceAmount(healthInsuranceLevel) {
    var healthInsuranceAmount = 0
    if (healthInsuranceLevel_Arr.length > 0) {
      healthInsuranceAmount = healthInsuranceLevel_Arr[healthInsuranceLevel - 1]["amount"]
      // console.log(healthInsuranceAmount)
    }
    return healthInsuranceAmount
  }

  useEffect(() => {
    // console.log(contractorAttendance)
  }, [contractorAttendance])

  function toCancel() {
    window.history.back();
  }
  function toSave(mReqContractorAttendance) {
    setIsLoading(true)
    if (type === "Monthly") {
      mReqContractorAttendance.info.salaryMonthly.InsuranceCostItem.Status = parseInt(Status)
    } else if (type === "Hourly") {
      mReqContractorAttendance.info.salaryHourly.InsuranceCostItem.Status = parseInt(Status)
    }
    api_updateContractorAttendance({
      mReqContractorAttendance,
      success: () => {
        if (type === "Monthly") {
          setVal2Token("salaryMonthly", { salaryMonthly: mReqContractorAttendance.info.salaryMonthly, contractorAttendance: mReqContractorAttendance }, tokenId)
        } else if (type === "Hourly") {
          setVal2Token("salaryHourly", { salaryHourly: mReqContractorAttendance.info.salaryHourly, contractorAttendance: mReqContractorAttendance }, tokenId)
        }
        console.log(mReqContractorAttendance)

        var obj = getval2Token("salary" + type, tokenId)
        console.log(obj)
        if (setIsLoading !== undefined) {
          setIsLoading(false)
        }
      },
      failure: () => {
        if (setIsLoading !== undefined)
          setIsLoading(false)
      }
    })
  }


  function setSalaryMonthly(setSalaryMonthly) {

  }

  var mRespCustomerPositionDetail = new RespCustomerPositionDetail({})
  var superTitle = contractorAttendanceSOPName
  var title = "月薪型出勤及加減項登錄"
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-6">
            <p>招募資訊</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"建立時間"} val={creatAt} />
          <SingleText title={"建立者"} val={creatName} />
          <SingleText title={"起迄期間"} val={dates} />
          <SingleSelect title={"作業狀態"}
            val={Status}
            attr={contractorAttendanceStatusAttr_Register}
            action={setStatus}
            hasBlank={false}
            size={3}
          />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-3">
            <SearchButton name={"根據“出勤及加減項登錄”清單計算"} action={getInsuranceList} icon={""} />
          </div>
          <div className="col-md-3">
            <p></p>
            <strong>特別注意！ 按下後已經編輯的資料會遺失！   </strong>
          </div>
        </div>
      </div>
      <div className="row">
        {
          Object.keys(InsuranceListItems).length === 0 ? <></> :
            CustomerPositionListItems.map((position, index) => (
              // console.log(InsuranceListItems[position.CustomerPositionDetail.customerPositionId])
              <InsuranceItemBox key={position.CustomerPositionDetail.customerPositionId} position={position} insurance={InsuranceListItems[position.CustomerPositionDetail.customerPositionId]} type={type} />
            ))
        }

      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-10">
            <strong>特別注意！   </strong>
          </div>

        </div>
      </div>
    </>



  return (
    <>
      <ContentBox superTitle={superTitle} title={title} titleSize={6} content={content} hasDrawer={false} />
      {Object.keys(InsuranceListItems).length === 0 ? <></> :
        <ContractorInsuranceCostList type={type} insuranceCostItem={InsuranceCostItem} contractorAttendance={contractorAttendance} toSave={toSave} />
      }
    </>
  )
}

function InsuranceItemBox({ position, insurance, type }) {
  const [mCustomerPositionListItem, setCustomerPositionDetail] = useState({})
  const [mRespCustomerPositionInfo_Insurance, setRespCustomerPositionInfo_Insurance] = useState({})

  const [shift, setShift] = useState("")
  const [job, setJob] = useState("")

  useEffect(() => {
    if (position !== undefined && position !== mCustomerPositionListItem) {
      // console.log(position)
      setCustomerPositionDetail(position)
      setShift(position.CustomerPositionDetail.info.shift)
      setJob(position.CustomerPositionDetail.info.job)
    }
  }, [position])

  useEffect(() => {
    if (insurance !== undefined && insurance !== mRespCustomerPositionInfo_Insurance) {
      // console.log(insurance)
      var mItem = new RespCustomerPositionInfo_Insurance({})
      mItem.fromJson(insurance)
      setRespCustomerPositionInfo_Insurance(mItem)
    }
  }, [insurance])

  useEffect(() => {
    // console.log(mRespCustomerPositionInfo_Insurance)
    // console.log(Object.keys(mRespCustomerPositionInfo_Insurance))
  }, [mRespCustomerPositionInfo_Insurance])

  function getGroupInfo() {
    if (parseInt(mRespCustomerPositionInfo_Insurance.groupInsuranceType) === GroupInsuranceType_NoNeed) {
      return <></>
    } else {
      var html = <>
        加保：{getDateOfInsuranceString(mRespCustomerPositionInfo_Insurance.dateOfInsurance)} /  &nbsp;
        保費 {mRespCustomerPositionInfo_Insurance.groupInsurancePremium} /  &nbsp;
        {getInsuranceBurdenTypeString(mRespCustomerPositionInfo_Insurance.groupInsuranceBurdenType)} /  &nbsp;
        預設統編 {mRespCustomerPositionInfo_Insurance.groupInsuranceGUI}  &nbsp;
      </>
      return html
    }
  }

  return (
    <>
      {(Object.keys(mCustomerPositionListItem).length === 0 || Object.keys(mRespCustomerPositionInfo_Insurance).length === 0) ? <></> :
        <div className="col-md-12">
          <div className="hr-line-dashed"></div>
          <div className="col-md-3">
            <p></p>
            <p className="text-success">{mCustomerPositionListItem.creatAt}</p>
          </div>

          <div className="col-md-9">
            <p className="text-success">
              {shift} /&nbsp;
                  {job} /&nbsp;
                  {position.Enrolment}人 /&nbsp;
                  {type === "Monthly" ?
                <>
                  底薪 {Number(mCustomerPositionListItem.CustomerPositionDetail.info.wageInfo.MonthlySalary).toLocaleString('en-US')} /&nbsp;
                  </>
                :
                <>
                  時薪 {Number(mCustomerPositionListItem.CustomerPositionDetail.info.wageInfo.InvoiceHourlyWage1).toLocaleString('en-US')} /&nbsp;
                  {Number(mCustomerPositionListItem.CustomerPositionDetail.info.wageInfo.PayHourlyWage2).toLocaleString('en-US')}
                </>
              }
            </p>
            <p className="text-success">
              勞健保：{getInsuranceSOPTypeString(mRespCustomerPositionInfo_Insurance.insuranceSOPTpye)} / &nbsp;
                   加保：{getDateOfInsuranceString(mRespCustomerPositionInfo_Insurance.dateOfInsurance)} / &nbsp;
                  勞保級距：{mRespCustomerPositionInfo_Insurance.laborInsuranceAmount.toLocaleString('en-US')} / &nbsp;
                  健保級距：{mRespCustomerPositionInfo_Insurance.healthInsuranceAmount.toLocaleString('en-US')} / &nbsp;
                  {getInsuranceBurdenTypeString(mCustomerPositionListItem.CustomerPositionDetail.info.wageInfo.InsuranceBurdenType)} / &nbsp;
                  預設統編{mRespCustomerPositionInfo_Insurance.insuredUnitGUI}
            </p>
            <p className="text-success">
              團保：{getGroupInsuranceTypeString(mRespCustomerPositionInfo_Insurance.groupInsuranceType)} &nbsp;
              {getGroupInfo()}
            </p>
          </div>
        </div>
      }
    </>
  )
}